import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { PaddingType } from 'common/types/styleTypes'
import React from 'react'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'
import { getMobileOrDesktop } from 'src/shared/utils/get-mobile-or-desktop'

interface PaddingControlProps {
  padding: Partial<PaddingType> | undefined
  mobilePadding?: Partial<PaddingType> | undefined
  update: (value: Partial<PaddingType>) => void
  mobileUpdate?: ((value: Partial<PaddingType>) => void) | undefined
  label?: string
  propertyKey: keyof PaddingType
  max?: number
}

export const PaddingControl = ({
  padding,
  mobilePadding,
  update,
  mobileUpdate,
  label = '',
  propertyKey = 'paddingTop',
  max = 10,
}: PaddingControlProps) => {
  const { isMobile } = useDeviceModeContext()

  const resultPadding = getMobileOrDesktop(padding, mobilePadding, isMobile)
  const resultUpdate = getMobileOrDesktop(update, mobileUpdate, isMobile)

  return (
    <RangeElement
      label={label}
      value={resultPadding?.[propertyKey] || 0}
      onChange={value =>
        resultUpdate({
          ...resultPadding,
          [propertyKey]: value,
        })
      }
      max={max}
    />
  )
}
